"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var NotificationType;
(function (NotificationType) {
    NotificationType["Announcement"] = "ANNOUNCEMENT";
    NotificationType["Portfolio"] = "PORTFOLIO";
    NotificationType["Order"] = "ORDER";
    NotificationType["Position"] = "POSITION";
    NotificationType["Transfer"] = "TRANSFER";
    NotificationType["Market"] = "MARKET";
    NotificationType["News"] = "NEWS";
    NotificationType["CorporateAction"] = "CORPORATE_ACTION";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
function NotificationTypeFromJSON(json) {
    return NotificationTypeFromJSONTyped(json, false);
}
exports.NotificationTypeFromJSON = NotificationTypeFromJSON;
function NotificationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.NotificationTypeFromJSONTyped = NotificationTypeFromJSONTyped;
function NotificationTypeToJSON(value) {
    return value;
}
exports.NotificationTypeToJSON = NotificationTypeToJSON;
